/* Vexillum — ALD-blueprint Phase 2 (B1–B4). Integrates with vexillum-refine.js:
   waits for .vex-refine-bar, then adds the collection-switcher button + left panel (B1),
   the grid-density toggle (B2), card colour-count lines (B3), and a “Hide sold out”
   quick-toggle in the Refine panel when the availability facet exists (B4). */
(function(){
  'use strict';
  var switchPanel=null;

  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  /* ---------- B1: switcher ---------- */
  function ensureSwitchPanel(){
    if(switchPanel&&document.body.contains(switchPanel))return switchPanel;
    var data=q('#VexSwitchData');if(!data)return null;
    switchPanel=document.createElement('div');switchPanel.className='vex-switch-panel';
    var head=document.createElement('div');head.className='vex-refine-head';
    var t=document.createElement('span');t.className='vex-refine-title';t.textContent='Browse';
    var c=document.createElement('button');c.type='button';c.className='vex-refine-close';c.setAttribute('aria-label','Close');c.innerHTML='&times;';
    c.addEventListener('click',closeSwitch);
    head.appendChild(t);head.appendChild(c);switchPanel.appendChild(head);
    qa('.vex-switch-group',data).forEach(function(g){
      if(!g.children.length)return;
      var wrap=document.createElement('div');wrap.className='vex-switch-group';
      var title=document.createElement('p');title.className='vex-switch-group__title';title.textContent=g.getAttribute('data-vex-group');
      wrap.appendChild(title);
      qa('a',g).forEach(function(a){
        var n=a.cloneNode(true);
        try{var u=new URL(n.href);if(u.pathname===location.pathname)n.classList.add('is-current');}catch(e){}
        wrap.appendChild(n);
      });
      switchPanel.appendChild(wrap);
    });
    document.body.appendChild(switchPanel);
    return switchPanel;
  }
  function vexScrim(){return q('.vex-refine-scrim');}
  function openSwitch(btn){
    var p=ensureSwitchPanel();if(!p)return;
    var s=vexScrim();
    qa('.facets.facets--vertical.vex-open,.vex-sort-panel.vex-open').forEach(function(e){e.classList.remove('vex-open');});
    p.classList.add('vex-open');btn.classList.add('is-open');
    if(s){s.classList.add('on');s.addEventListener('click',closeSwitch);}
    document.body.style.overflow='hidden';
  }
  function closeSwitch(){
    if(switchPanel)switchPanel.classList.remove('vex-open');
    var b=q('.vex-switch-btn');if(b)b.classList.remove('is-open');
    var s=vexScrim();
    var othersOpen=q('.facets.facets--vertical.vex-open')||q('.vex-sort-panel.vex-open');
    if(s&&!othersOpen){s.classList.remove('on');document.body.style.overflow='';}
  }
  function collectionTitle(){
    var h=q('h1');var t=h?h.textContent.trim():'';
    if(!t||t.length>40)t='Browse';
    return t;
  }
  function ensureSwitchBtn(bar){
    if(q('.vex-switch-btn',bar))return;
    if(!q('#VexSwitchData'))return;
    var b=document.createElement('button');b.type='button';b.className='vex-refine-btn vex-switch-btn';
    b.innerHTML='<span class="vex-switch-label"></span><span class="vex-switch-plus">+</span>';
    b.querySelector('.vex-switch-label').textContent=collectionTitle();
    b.addEventListener('click',function(){
      if(switchPanel&&switchPanel.classList.contains('vex-open'))closeSwitch();else openSwitch(b);
    });
    bar.insertBefore(b,bar.firstChild);
  }

  /* ---------- B2: density toggle ---------- */
  var ICON_LARGE='<svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor"><rect x="0" y="0" width="6.5" height="15"/><rect x="8.5" y="0" width="6.5" height="15"/></svg>';
  var ICON_COMPACT='<svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor"><rect x="0" y="0" width="3" height="15"/><rect x="4" y="0" width="3" height="15"/><rect x="8" y="0" width="3" height="15"/><rect x="12" y="0" width="3" height="15"/></svg>';
  function applyDensity(){
    var d=null;
    try{d=localStorage.getItem('vexDensity');}catch(e){}
    if(d==='large'||d==='compact')document.documentElement.setAttribute('data-vex-density',d);
    else document.documentElement.removeAttribute('data-vex-density');
    qa('.vex-density__btn').forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-density')===(d||''));});
  }
  function setDensity(d){
    try{var cur=localStorage.getItem('vexDensity');if(cur===d){localStorage.removeItem('vexDensity');}else{localStorage.setItem('vexDensity',d);}}catch(e){}
    applyDensity();
  }
  function ensureDensity(bar){
    if(q('.vex-density',bar))return;
    var w=document.createElement('span');w.className='vex-density';
    [['large',ICON_LARGE],['compact',ICON_COMPACT]].forEach(function(o){
      var b=document.createElement('button');b.type='button';b.className='vex-density__btn';b.setAttribute('data-density',o[0]);
      b.setAttribute('aria-label',o[0]==='large'?'Larger grid':'Compact grid');b.innerHTML=o[1];
      b.addEventListener('click',function(){setDensity(o[0]);});
      w.appendChild(b);
    });
    var sw=q('.vex-switch-btn',bar);
    if(sw&&sw.nextSibling)bar.insertBefore(w,sw.nextSibling);else bar.insertBefore(w,bar.firstChild);
    applyDensity();
  }

  /* ---------- B3: colour-count line on cards ---------- */
  function colourCounts(){
    qa('.product-grid .product-card').forEach(function(card){
      if(card.querySelector('.vex-colour-count'))return;
      var sw=qa('[class*="swatch"] input, [class*="swatch"] label, [class*="swatch"] a',card);
      var n=0,seen={};
      sw.forEach(function(el){var v=(el.value||el.getAttribute('aria-label')||el.title||el.textContent||'').trim();if(v&&!seen[v]){seen[v]=1;n++;}});
      if(n<2)return;
      var price=card.querySelector('[class*="price"]');
      var line=document.createElement('span');line.className='vex-colour-count';line.textContent=n+' colours available';
      if(price&&price.parentElement)price.parentElement.insertBefore(line,price.nextSibling);
    });
  }

  /* ---------- B4: hide-sold-out toggle in Refine ---------- */
  function ensureToggles(){
    var f=q('.facets.facets--vertical');if(!f)return;
    if(q('.vex-refine-toggles',f))return;
    var avail=q('input[name="filter.v.availability"][value="1"]',f);
    if(!avail)return;
    var box=document.createElement('div');box.className='vex-refine-toggles';
    var lab=document.createElement('label');lab.className='vex-refine-toggle';
    var cb=document.createElement('input');cb.type='checkbox';cb.checked=avail.checked;
    cb.addEventListener('change',function(){avail.checked=cb.checked;avail.dispatchEvent(new Event('change',{bubbles:true}));});
    lab.appendChild(cb);lab.appendChild(document.createTextNode('Hide sold out'));
    box.appendChild(lab);
    var head=q('.vex-refine-head',f);
    if(head&&head.nextSibling)f.insertBefore(box,head.nextSibling);else f.appendChild(box);
  }

  function run(){
    try{
      var bar=q('.vex-refine-bar');
      if(bar){ensureSwitchBtn(bar);ensureDensity(bar);}
      colourCounts();
      ensureToggles();
      applyDensity();
    }catch(e){}
  }
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,120);}).observe(document.body,{childList:true,subtree:true});
})();
